import { isTransferInProgress } from '@shared/calls/transfer'
import type { CallTransferState } from '../../../types/voice-call'

export function TransferInProgressBar({
  transfer,
}: {
  transfer: CallTransferState | undefined
}) {
  if (!transfer || !isTransferInProgress(transfer.phase)) return null

  const target = transfer.targetDisplayName ?? 'the other line'
  // The party being forwarded (briefly on hold) and the transferrer both only
  // see status — a blind transfer has no mid-flight controls.
  const isHeldParty = transfer.onHold === true

  const label = isHeldParty
    ? `Connecting you to ${target}…`
    : `Forwarding the call to ${target}…`

  return (
    <div
      className="mb-4 rounded-xl border border-amber-200/40 bg-amber-500/15 px-4 py-3 text-center text-sm text-amber-50"
      role="status"
      aria-live="polite"
    >
      <p>{label}</p>
    </div>
  )
}
